import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authClient } from '../lib/auth-client';

// Thin gate around Better Auth's useSession hook. Lands here:
//   - loading  → a near-invisible placeholder (no flicker on fast nets)
//   - no user  → redirect to /login, preserving where they came from
//   - user ok  → render children
//
// This is DEFENSE IN DEPTH only. Real authorization happens on the
// server; a hostile client that bypasses this gate still can't reach
// /api/* without the cookie being valid.
export function SessionGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-slate-400">
        Loading…
      </div>
    );
  }

  if (!data?.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
